import React from "react";
import { Box } from "@mui/material";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import DetalleFacturaModal from "../components/DetalleFacturaModal";
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/layout/PageHeader";

const DetalleFacturaPage = () => {
  const { cod } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const volver = () => {
    if (location.state?.from) {
      navigate(location.state.from);
      return;
    }
    navigate(-1);
  };

  return (
    <DashboardLayout>
      <PageHeader title={`Detalle de Factura #${cod}`} onBack={volver} />

      <Box sx={{ p: { xs: 1, md: 1.5 } }}>
        <DetalleFacturaModal
          cod={cod}
          onClose={volver}
          pageMode
        />
      </Box>
    </DashboardLayout>
  );
};

export default DetalleFacturaPage;
